module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/003"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/004"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/005"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(": G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROWING")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("P IN THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTRY OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOW")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USINESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/003"
    }
  }, [_vm._v("Chapter 1: Harlem and the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/007"
    }
  }, [_vm._v("Chapter 2: The Forty-four-year-old Midget")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/008"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(": B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAKING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/009"
    }
  }, [_vm._v("Chapter 3: Fort Warren")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/010"
    }
  }, [_vm._v("Chapter 4: “Hungry and Mad”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Big Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: A Crucial Year")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OP OF THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAP")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Return")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: "), _c('em', [_vm._v("Mr. Wonderful")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Kim, Harry, and Loray")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Big Screen, Little Screen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Lovers and Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Rat Pack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: May")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: “A One-man Band”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Pallies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: "), _c('em', [_vm._v("Golden Boy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: “On the Seventh Day, He Works”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: A Book, a Film, and a TV Series")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: That’s All!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(": A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GING")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IPSTER FROM")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("-L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Sad Times and Swinging Times")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Altovise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Entering the Seventies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: The Candy Man and the Man in the White House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: An Open Marriage")]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: A New Showroom, a New Show, and an Old Musical")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Difficult Adjustments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE")]), _vm._v(": “N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" I "), _c('em', [_vm._v("L")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: “I’ve Never Felt Better”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Turning Sixty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: “The Alternative Is Something Else Again”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: “I Don’t Think This Is the Way"), _c('br'), _vm._v("I’m Supposed to Go Out”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/040",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/041",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Afterword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/042",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/043",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/044",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Filmography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/045",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Discography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/046",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3496e2c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/002.vue
// module id = 66
// module chunks = 0